import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ArrowRight } from 'lucide-react';
import './Campus.css';

import gallery_1 from '../assets/gallery-4.jpg';
import gallery_2 from '../assets/gallery-6.jpg';
import gallery_3 from '../assets/gallery-1.jpg';
import gallery_4 from '../assets/gallery-2.jpg';

const Campus = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  const images = [gallery_1, gallery_2, gallery_3, gallery_4];

  return (
    <section className="campus-section">
      <div className="campus-container">

        {/* Heading */}
        <div className="campus-header" data-aos="fade-down">
          <h2 className="contact-title">Our Campus</h2>
          <p className="campus-desc">
            Explore our modern infrastructure and vibrant learning spaces
          </p>
        </div>

        {/* Horizontal Gallery */}
        <div className="campus-gallery">
          {images.map((img, index) => (
            <div
              key={index}
              className="image-card"
              data-aos="fade-up"
              data-aos-delay={index * 120}
            >
              <img src={img} alt={`Campus ${index + 1}`} />
              <div className="image-overlay"></div>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="campus-footer" data-aos="zoom-in">
          <button className="btn-explore1" onClick={() => navigate('/campus')}>
            <span>See More Here</span>
            <ArrowRight size={18} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default Campus;
